import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export function FontWeightTest() {
  return (
    <div className="container mx-auto p-8 space-y-8">
      <Card>
        <CardHeader>
          <CardTitle>Font Weight Test - Inter Font Family</CardTitle>
          <CardDescription>
            All weights should look visibly different. If they look the same, fonts are not loading correctly.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Test with explicit font-weight classes */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold mb-4">Using Tailwind Font Weight Classes:</h3>
            
            <div className="space-y-2">
              <p className="font-light text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Light (300):</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p className="font-normal text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Normal (400):</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p className="font-medium text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Medium (500):</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p className="font-semibold text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Semibold (600):</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p className="font-bold text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Bold (700):</span>
                The quick brown fox jumps over the lazy dog
              </p>

              <p className="font-extrabold text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Extrabold (800):</span>
                The quick brown fox jumps over the lazy dog
              </p>

              <p className="font-black text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Black (900):</span>
                The quick brown fox jumps over the lazy dog
              </p>
            </div>
          </div>

          {/* Test with inline styles */}
          <div className="space-y-4 pt-6 border-t">
            <h3 className="text-lg font-semibold mb-4">Using Inline Styles (Verification):</h3>
            
            <div className="space-y-2">
              <p style={{ fontWeight: 300 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 300:</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p style={{ fontWeight: 400 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 400:</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p style={{ fontWeight: 500 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 500:</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p style={{ fontWeight: 600 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 600:</span>
                The quick brown fox jumps over the lazy dog
              </p>
              
              <p style={{ fontWeight: 700 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 700:</span>
                The quick brown fox jumps over the lazy dog
              </p>

              <p style={{ fontWeight: 800 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 800:</span>
                The quick brown fox jumps over the lazy dog
              </p>

              <p style={{ fontWeight: 900 }} className="text-2xl">
                <span className="inline-block w-32 text-sm text-muted-foreground">Weight 900:</span>
                The quick brown fox jumps over the lazy dog
              </p>
            </div>
          </div>

          {/* Visual comparison grid */}
          <div className="space-y-4 pt-6 border-t">
            <h3 className="text-lg font-semibold mb-4">Side-by-Side Comparison:</h3>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <p className="font-light text-xl">Light (300)</p>
                <p className="font-normal text-xl">Normal (400)</p>
                <p className="font-medium text-xl">Medium (500)</p>
                <p className="font-semibold text-xl">Semibold (600)</p>
              </div>
              <div className="space-y-2">
                <p className="font-bold text-xl">Bold (700)</p>
                <p className="font-extrabold text-xl">Extrabold (800)</p>
                <p className="font-black text-xl">Black (900)</p>
              </div>
            </div>
          </div>

          {/* Diagnostic info */}
          <div className="space-y-2 pt-6 border-t text-sm text-muted-foreground">
            <p><strong>Expected Result:</strong> Each line should look progressively bolder</p>
            <p><strong>If all weights look the same:</strong> Font files are not loading or are corrupted</p>
            <p><strong>Current font-family:</strong> Inter, sans-serif</p>
            <p><strong>Font source:</strong> Google Fonts (loaded in index.html)</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
